import { render, staticRenderFns } from "./FrrModal.vue?vue&type=template&id=564392d2&scoped=true&"
import script from "./FrrModal.vue?vue&type=script&lang=js&"
export * from "./FrrModal.vue?vue&type=script&lang=js&"
import style0 from "./FrrModal.vue?vue&type=style&index=0&id=564392d2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564392d2",
  null
  
)

export default component.exports